import { render, staticRenderFns } from "./err404.vue?vue&type=template&id=70a57ece&scoped=true"
import script from "./err404.vue?vue&type=script&lang=js"
export * from "./err404.vue?vue&type=script&lang=js"
import style0 from "./err404.vue?vue&type=style&index=0&id=70a57ece&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a57ece",
  null
  
)

export default component.exports